// ABOUTME: Validates Contact email uniqueness before advancing the creation form.
// ABOUTME: Keeps active Contact duplicate handling without treating Users as Contacts.

import { apiDirectCall } from "customHooks/useApi/api";
import { useGlobalDialog } from "_ReactContext/GlobalDialogContext";
import { navigate } from "@gatsbyjs/reach-router";

export const useNextPageFunctionsNewContact = (companyId: number, t: any) => {
    const { callDialog } = useGlobalDialog();

    const verifyEmailAddress = async (nextPageFunction: any, values: any) => {
        const paramsContactEmailNotExists = {
            fieldValueToValidate: values.email,
            validationType: "contactEmailNotExists",
            companyId
        };
        const urlContact = "/contact/genericvalidationcontact"; //genericValidationAPI
        const validationContact = await apiDirectCall(
            urlContact,
            "post",
            paramsContactEmailNotExists
        );
        const validContactExists = validationContact.data.validationResult;

        if (validContactExists.result) {
            callDialog({
                title: t("contactEmailExists_ModalTitle"),
                bodyText: t("contactEmailExists_Message"),
                agreeButtonText: t("contactEmailExists_Yes"),
                disagreeButtonText: t("contactEmailExists_No"),
                agreeFunction: async () => {
                    navigate(`/contact/edit/${validContactExists.uuid}`);
                },
                disagreeFunction: () => {
                    nextPageFunction(true);
                }
            });
        } else {
            nextPageFunction();
        }
    };

    const nextPageFunctions = [{ page: 1, fn: verifyEmailAddress }];

    return nextPageFunctions;
};
